import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatText',
})
export class FormatTextPipe implements PipeTransform {
  transform(rawString: string): string {
    if (!rawString) return rawString;
    return rawString.replace(/\\n/g, '\n').replace(/\/n/g, '\n');
  }
}
